<script lang="ts">
    export let direction = "right";
    export let isPaused = false;
    export let rootElement;
    let flipsvg = false;

    if (direction == "left") {
      flipsvg = true;
    }
</script>

<style lang="scss">
  * {
    .shapes > * {
    opacity: 0;
    animation-duration: 5s;
    animation-iteration-count: infinite;
    animation-timing-function: steps(1);
  }
  @keyframes lunge-1 {
    0%,
    25% {
      opacity: 1;
    }
    25%,
    50% {
      opacity: 0;
    }
    50%,
    75% {
      opacity: 1;
    }
    75%,
    100% {
      opacity: 0;
    }
  }
  #lunge-1 {
    animation-name: lunge-1;
  }
  @keyframes lunge-2 {
    0%,
    25% {
      opacity: 0;
    }
    25%,
    50% {
      opacity: 1;
    }
    50%,
    100% {
      opacity: 0;
    }
  }
  #lunge-2 {
    animation-name: lunge-2;
  }
  @keyframes lunge-3 {
    0%,
    75% {
      opacity: 0;
    }
    75%,
    100% {
      opacity: 1;
    }
  }
  #lunge-3 {
    animation-name: lunge-3;
  }

  .paused .shapes > * {
    filter: grayscale(100%);
      opacity: 0.8;
      animation-play-state: paused;
    }
  
  .flip .shapes > *{
    transform-origin: center center;
    transform: scaleX(-1); }

}
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 529.8 673.5" height="100%" width="100%">>
<g class:paused={isPaused} class:flip={flipsvg}>
  <g class="shapes" bind:this={rootElement}>
    <g id="lunge-1">
      <path
        fill="var(--pants)"
        d="m76 320 8-1c1 6 1 12 5 16a29 29 0 0 1 4 28c-3 9 6 13 5 21 0 1 4 2 4 0 3-4 4 2 5 1-2 12 0 25-2 37l-2 10c-1 12-1 12-13 13-19 1-37 3-56 3-12-1-12-1-12-13 0-25-3-50-11-74-4-11-5-23-4-35 6 6 13 5 21 3l30-6 8 1c5 1 8 0 10-4Z"
      />
      <path fill="var(--shirt)" d="M95 288Z" />
      <path fill="var(--hair)" d="M36 76Z" />
      <path
        fill="var(--hair)"
        d="M117 643c2-2 4-4 3-8-1-3-4-5-7-5-4 0-8-2-12-4a187 187 0 0 1-27-16c-4-3-7-5-7-10 0-2 0-6-5-3a3 3 0 0 1-1 0c-2 0-2 3-3 4 2 5 0 8-5 10l-1 8c-4 3-9 4-12 10-4 8-13 5-18-5l-4-6c-2 0-3-1-3-3s1-3 3-3a1 1 0 0 1 1-1c-1-1-1-3-3-2a4 4 0 0 0-3 4c0 6-1 11 1 17v3-1 9a6 6 0 0 0 2-2 6 6 0 0 1-2 2c1 4-1 8 1 12a3 3 0 0 0 3 3c5 3 11 4 17 5a2 2 0 0 0 3 1h4l8 2 2 1 12 6 4 1c6 2 13 2 19 1 9-2 17-3 24-9 6-3 8-10 4-14-3-4-1-5 2-7Zm-101-7a7 7 0 0 0-1 0 7 7 0 0 1 1 0Zm0 3a3 3 0 0 0 0-1 3 3 0 0 1 0 1Z"
      />
      <path fill="var(--shirt)" d="M110 317ZM111 318Z" />
      <path
        fill="var(--pants)"
        d="M76 320c-2 4-5 5-10 3h-8c6-2 12-4 18-3Z"
      />
      <path
        fill="var(--hair)"
        d="M102 4c-3-4-7-2-11-2-3 0-7 1-9-2H53c-3 4-8 3-12 4-14 3-23 13-22 28s4 30 8 44a4 4 0 0 0 2 5c3 0 6-1 7-5 7-6 2-13 1-20-1-5-1-9 3-12 6-2 10 1 12 7 2 8 6 9 12 3a16 16 0 0 0 2-3l2-4c1-6 2-10 8-13 3-1 4-5 3-8-1-8 2-11 9-8 3 0 6 2 8 3l2-2a26 26 0 0 0 2-3c2-4 4-8 2-12Z"
      />
      <path
        fill="var(--hair)"
        d="M18 618c-2 0-3-1-3-3s1-3 3-3v2h-1a6 6 0 0 0 1 1v2Z"
      />
      <path fill="var(--pants)" d="M18 616v-1l1 1a9 9 0 0 0-1 0Z" />
      <path
        fill="var(--pants)"
        d="M18 615a6 6 0 0 1-1-1s1 0 1-1a1 1 0 0 1 0 2Z"
      />
      <path
        d="M108 296c-6-35-7-70-5-106 0-9 0-19-5-27-2-9-6-17-11-25-1-4-3-7-6-10a38 38 0 0 0-8-13l-2-4c-3 1-3 3-3 5 0 6-3 8-7 5l-9-2c-5-6-12-8-19-10l-9-12c-8 5-9 15-13 22s-5 15-11 21v27a178 178 0 0 1 12 86c-1 10-1 21-4 31-6 14-3 28-1 42 6 6 13 5 21 3l30-6c6-2 12-4 18-3l8-1a17 17 0 0 0-6-11c-9-8-15-19-24-27-7-5-10-15-13-24-1-3-4-6-3-10-1-1-2 2-2 0v-17l1-1c-4-2-1-6-3-10-2-7-5-15-4-23-5-2-2-6-2-9a44 44 0 0 1 0-12c11 3 22 1 33 1 3 1 6-1 7 3a7 7 0 0 0 1 0 7 7 0 0 1-1 0v33c0 5 0 10 3 14 4 5 4 12 7 18 2 3 4 7 4 11 3 0 1 5 4 6l1 2v6c5 3 5 8 6 13 3 1 2 3 2 6 2 0 3 1 3 2v3c4 2 4 7 5 11s2 7 6 8c2-5 0-11-1-16ZM72 187l-1-1 1-1 1 1-1 1Zm10-10a3 3 0 0 0-2-3 3 3 0 0 1 2 3Zm-1 19a96 96 0 0 1 1 13 96 96 0 0 0-1-13Zm6 61a20 20 0 0 0 0-3 20 20 0 0 1 0 3Z"
        fill="var(--shirt)"
      />
      <path d="m72 185 1 1-1 1-1-1 1-1Z" fill="var(--pants)" />
      <path
        fill="var(--flesh)"
        d="m111 318-1-1-1-5c-4-1-5-4-6-8s-1-9-5-11v-3a2 2 0 0 1-3-1 2 2 0 0 0 3 1c0-1-1-2-3-2 0-3 1-5-2-6l-1 6a3 3 0 0 0-2 1 3 3 0 0 1 2-1l1-6c-1-5-1-10-6-13v-6l-1-2c-3-1-1-6-4-6 0-4-2-8-4-11-3-6-3-13-7-18-3-4-3-9-3-14v-33c-1-4-4-2-7-3-11 0-22 2-33-1a44 44 0 0 0-1 12c1 3-2 7 3 9-1 8 1 16 4 23 2 4-1 8 3 10l-1 1v17c0 2 1-1 2 0-1 4 2 7 3 10 3 9 6 19 13 24 9 8 15 19 24 27a17 17 0 0 1 6 11c1 6 1 12 5 16a29 29 0 0 1 4 28c-3 9 6 13 5 21 0 1 4 2 4 0 3-4 4 2 5 1 7 1 6-6 9-8 1 2 0 5 3 5s3-3 4-5l3-13c1-10 1-20-4-28l-11-18ZM24 493a56 56 0 0 0-4 8c-3 9-8 17-7 26l4 49c1 12 3 23 2 35a1 1 0 0 0-1 1v1a1 1 0 0 1 0 2l1 1a9 9 0 0 0-1 0v2l4 6c5 10 14 13 18 5 3-6 8-7 12-10l1-8c5-2 7-5 5-10 1-1 1-4 3-4v-8l-1-4c2-14-1-28 0-42v-5c2-2 1-4 1-7 2-10 1-22 7-30 11-17 16-37 22-56-19 1-37 4-56 3 2 16 0 31-10 45Zm-2 131v-2 2Zm36-29a8 8 0 0 0-1 1v1-1a8 8 0 0 1 1-1 13 13 0 0 1 0-2 13 13 0 0 0 0 2Zm5-91-2-4 2 4Zm-2-4a5 5 0 0 0-3-1 5 5 0 0 1 3 1ZM18 615ZM29 81c-2 5-1 11-5 16l9 12c7 2 14 4 19 10l9 2c4 3 7 1 7-5 0-2 0-4 3-5-2-10 4-17 14-16 5 1 11 1 12-3 1-7 7-13 6-21a4 4 0 0 1 2-4c4-4 3-7 0-11-2-3-6-5-5-9 2-9-3-17-4-26-2-1-5-3-8-3-7-3-10 0-9 8 1 3 0 7-3 8-6 3-7 7-8 13l-2 4a15 15 0 0 1-2 3c-6 6-10 5-12-3-2-6-6-9-12-7-4 3-4 7-3 12 1 7 6 14-1 20-1 4-4 5-7 5Z"
      />
    </g>
    <g id="lunge-2">
      <path
        fill="var(--hair)"
        d="M530 598c-6 7-13 11-21 11-18 2-35 3-53 1l-31-2c-2 0-5 0-4-4 4-12 3-24 10-35 0-2 0-5 3-3l7 9c3 3 6 5 9 2 4-3 12-4 10-12-1-6 2-9 7-10 2 2 2 4 2 6 0 10 6 14 13 17 14 5 26 13 41 13 3 0 5 2 7 3ZM105 618c2 4-2 4-4 4-5-1-6 2-7 6 0 6 0 11 7 13 4 1 7 4 11 6 2 2 3 4 2 7 0 3-2 4-4 4l-15 4H83l-1-1c-16-3-23-14-24-30-1-9-5-18-8-27-3-11 2-18 14-18l15 2c1-1 1 1 1 2l-2 4c-5 3-7 7-4 13 4 5 15 10 19 8 5-3 9-1 12 3Z"
      />
      <path
        fill="var(--pants)"
        d="M419 435a173 173 0 0 0-13 30c-3 3-3 9-6 12l-3-4-10-30c-3-9-4-18-10-26l-1-4c4-6 8-11 14-14 4 0 8 3 13-1 2-2 4 1 6 2 6 3 11 8 19 3 2-1 7 1 8 5-4 1-5 4-6 7-3 6-7 11-9 18Z"
      />
      <path
        fill="var(--shirt)"
        d="M381 316a7 7 0 0 1-3-4 7 7 0 0 0 3 4c1-7-2-13-4-19-5-16-18-26-27-39a15 15 0 0 0-8-6l-6-3c-3-5-8-8-13-10-7-3-15-7-23-9-7 10-14 20-19 31-10 23-9 47-4 70 2 16 6 32 9 47 1 6 2 12 0 18-4 11-10 21-12 33-1 6-6 13-4 20l14 4c13 2 26 7 40 9 12 1 22-1 30-11 0-4-4-6-7-9-2-3-4-7-3-11v-2c-6-8-10-16-12-25a4 4 0 0 1-1-1c-1-7-7-11-6-18l-11-29c-1-5 7-14 11-14 8-1 15 1 22-3 6-2 9 3 9 7 1 6 4 12 4 18 3 5 5 12 5 18v3c5 5 2 11 3 16 3 1 2 4 3 6a8 8 0 0 0 5 6c4-6 8-12 14-14-1-28-6-55-9-83Zm-3-7v1-1Z"
      />
      <path
        fill="var(--pants)"
        d="m366 464-1-1-3-3-8-9c-8 10-18 12-30 11-14-2-27-7-40-9-1 3-3 3-5 2 1-3 3-2 5-2l-14-4c0 7-1 15 3 22v1c0 5-7 10 1 14 1 1 0 4-1 5l-8 26-7 18c-2 6-6 13-6 20 9 7 18 13 29 14l25 1a72 72 0 0 1 29-8c7 0 8-3 9-8 1-15 1-31 4-47 5-13 10-26 28-26-1-7-8-11-10-17Z"
      />
      <path
        fill="var(--hair)"
        d="M369 138h-9c-16-3-31-1-47 2-13 2-19 14-20 23-1 18 5 36 10 54 4-1 6-3 8-6 5-6 1-13 0-20-2-9 0-12 9-12 4 3 6 6 6 11 1 4 3 4 6 3 6-3 10-7 10-13 1-5 3-7 6-9 5-2 6-6 5-11-2-5 1-8 6-7a48 48 0 0 1 6 1l4 3a26 26 0 0 0 7-10c2-6-1-9-7-9Z"
      />
      <path fill="var(--pants)" d="M284 453c-1 3-3 3-5 2 1-3 3-2 5-2Z" />
      <path
        fill="var(--flesh)"
        d="M252 555c-2 1-3 3-3 5-2 7-6 13-9 20-2 5-5 7-11 6l-9-1c-17-4-35-6-52-3-27 5-53 8-80 7l-8 1-2 4c-5 3-7 7-4 13 4 5 15 10 19 8 5-3 9-1 12 3 3-2 6-2 9-2a102 102 0 0 1 33 3c34 10 70 8 104 10 11 1 19-4 23-13 5-9 11-15 17-23 5-7 11-14 15-23l-25-1c-11-1-20-7-29-14ZM478 418l-42-10c-4 1-5 4-6 7v7-7c-3 6-7 11-9 18l-2 2a173 173 0 0 0-13 30 305 305 0 0 0 39 2c4-1 5 0 3 4a63 63 0 0 0-4 15c-2 19-1 38-5 56-2 8-2 16-5 24l7 9c3 3 6 5 9 2 4-3 12-4 10-12-1-6 2-9 7-10-1-10 3-19 7-29l7-17c6-17 11-34 18-50 8-18-2-38-21-41Zm-50 19a2 2 0 0 0-3-3 2 2 0 0 1 3 3ZM378 202c5-3 3-7 1-10-3-4-6-7-5-11 0-8-3-16-5-24l-4-3a48 48 0 0 0-6-1c-5-1-8 2-6 7 1 5 0 9-5 11-4 2-5 4-6 9 0 6-4 10-10 13-3 1-5 1-5-3-1-5-3-8-7-11-9 0-11 3-9 12 1 7 5 14 0 20-2 3-4 5-8 6-2 4-2 9-3 13 8 2 16 6 23 9 5 2 10 5 13 10l6 3 1-6c2-12 6-15 17-15h4c5 0 8-3 8-7 0-7 8-12 4-20l2-2Z"
      />
      <path
        fill="var(--flesh)"
        d="M410 499c-7-6-10-14-10-22l-3-4-10-30c-3-9-4-18-10-26l-1-4a8 8 0 0 1-5-6c-1-2 0-5-3-6-1-5 2-11-3-16v-3c0-6-2-12-5-18 0-6-3-12-4-18 0-4-3-9-9-7-7 4-14 2-21 3-5 0-13 9-12 14l11 29c0 7 5 11 6 18a4 4 0 0 0 1 1c2 9 6 17 12 25v2c-1 5 1 8 3 11 3 3 7 5 7 9l9 9 2 3 2 1h-1c3 6 9 10 10 17a29 29 0 0 1 9 19c0 7 1 15 7 21 5 6 6 12 2 19-2 5 0 7 4 8 3 3 5 0 8 0 9-1 19-13 19-22 0-12-7-20-15-27Zm-13 4a1 1 0 0 1 0 1 1 1 0 0 0 0-1Z"
      />
    </g>
    <g id="lunge-3">
      <path
        fill="var(--flesh)"
        d="m431 458-42-10c-4 1-4 3-5 6l-1 8 1-8c-4 6-8 12-10 19l-2 2a173 173 0 0 0-13 29 305 305 0 0 0 39 2c3 0 5 1 3 5a63 63 0 0 0-4 15c-3 18-2 38-6 56-2 8-2 16-5 24l7 8c3 2 6 6 9 3 4-3 12-4 10-12-1-6 2-9 7-10-1-10 3-20 7-29l7-17 19-50c8-18-2-37-21-41Zm-50 18a2 2 0 0 0-3-2 2 2 0 0 1 3 2ZM258 550l3-43c-2-3-5-4-8-4l-7 1 7-1c-6-3-12-6-20-6l-2-1a173 173 0 0 0-31-9 304 304 0 0 0 5 39c0 4 0 5-4 4a63 63 0 0 0-16-1c-19 0-37 5-56 4-8-1-48 2-56 0a99 99 0 0 0-8 8c-2 3-4 8-1 10 4 3 6 11 14 8 5-2 32 3 47 3s16 0 26 2l18 4 52 10c19 5 37-9 37-28Zm-27-46a2 2 0 0 0 2-3 2 2 0 0 1-2 3Z"
      />
      <path
        fill="var(--pants)"
        d="m350 422-24-10a5 5 0 0 1-2-2c-3 1-5-1-8-1-7 3-10 9-14 14v5c6 7 8 17 11 25a3512 3512 0 0 1 12 34c-9 23-8 47 24 27 17-2 24 3 29-7l5-42c2-7 9-14 13-20l-40-20-6-3Z"
      />
      <path
        fill="var(--shirt)"
        d="M307 326a7 7 0 0 1-3-4 7 7 0 0 0 3 4c1-7-2-13-4-19-5-16-18-26-27-39a15 15 0 0 0-8-6c-2-1-4-3-7-2-2-6-8-8-12-10-8-4-15-8-23-9a114 114 0 0 0-23 101l9 47c1 5 2 11 0 17-4 11-10 21-12 33-2 7-6 13-4 20l14 4 39 9c13 1 23 0 31-11-1-4-4-6-7-9s-4-6-3-10l-1-3c-5-8-10-16-12-25a3 3 0 0 1 0-1c-1-6-7-11-7-18l-10-29c-1-4 6-13 11-14 7-1 15 1 22-2 5-3 9 2 9 6 1 6 4 12 4 18 3 6 5 12 5 19v2c5 5 2 11 3 17 3 0 2 3 2 5a8 8 0 0 0 6 6c4-5 7-11 14-14-1-28-7-55-9-83Zm-4-7Z"
      />
      <path
        fill="var(--pants)"
        d="m196 485-1 22c26 8 54 7 75 3 30 4 80 19 31-19-1-7-7-10-9-16v-1l-2-1-2-3-8-8c-8 10-18 12-31 10l-40-9c0 4-2 3-5 2 2-2 4-1 5-2l-13-4-1 23c0 4 0 2 1 3Z"
      />
      <path
        fill="var(--hair)"
        d="M295 148h-9c-16-2-31-1-47 2-13 3-19 14-20 23-1 19 5 36 10 54l7-5c6-7 1-14 0-21-1-8 1-12 10-12 3 3 6 7 6 11 1 4 3 4 6 3 5-3 10-7 10-13 0-4 2-7 6-9 5-2 6-6 4-11-1-5 1-7 6-7a49 49 0 0 1 7 1l4 3a26 26 0 0 0 6-9c2-6 0-10-6-10Z"
      />
      <path fill="var(--pants)" d="M210 463c-1 4-3 3-5 2 1-2 3-1 5-2Z" />
      <path
        fill="var(--flesh)"
        d="M304 212c5-3 3-7 0-10-2-3-5-7-5-11 1-8-2-16-4-24l-4-3a49 49 0 0 0-6-1c-6 0-8 2-7 7 2 5 1 9-4 11-4 2-6 5-6 9 0 7-5 10-10 13-3 1-5 1-6-3 0-4-3-8-6-11-9 0-11 4-10 12 1 7 6 14 0 21l-7 5c-2 4-2 9-3 14 8 1 15 5 23 9 4 2 10 4 12 10 3-1 5 1 7 2l1-6c1-12 5-15 17-15h4c5 0 7-2 8-7 0-7 7-12 4-20l2-2ZM335 509c-6-6-9-13-10-22l-3-4-9-30c-3-8-5-18-11-25v-5a8 8 0 0 1-6-6c0-2 1-5-2-5-1-6 2-12-3-17v-2c0-7-2-13-5-19 0-6-3-12-4-18 0-4-4-9-9-7-7 4-15 2-22 3-5 1-12 10-11 14l10 29c0 7 6 12 7 18a3 3 0 0 0 0 1c2 9 7 17 12 25l1 3c-1 4 0 7 3 10s6 5 7 9l8 9 2 3 2 1v1c2 6 8 9 9 16a29 29 0 0 1 9 19c1 8 2 15 8 21 5 6 6 12 2 19-3 5 0 7 4 8 2 4 5 0 8 0 8 0 18-13 18-22 0-12-7-20-15-27Zm-12 5Z"
      />
      <path
        fill="var(--hair)"
        d="M106 560c1 5-3 4-5 4-5-1-6 2-6 7-1 6-1 11 7 13l10 6c3 1 3 4 3 6 0 3-2 5-5 5l-15 4H83v-1c-17-3-23-14-25-30-1-9-5-18-7-27-4-12 1-18 13-18 5 0 10 2 15 1l2 3-3 4c-4 3-7 7-3 13 3 5 14 10 19 7 5-2 8 0 12 3ZM490 634c-6 8-14 11-24 12-19 2-38 3-57 1l-34-2c-3-1-6 0-5-4 4-13 3-27 10-40 1-2 1-5 4-3l7 10c2 3 7 6 11 3 4-4 13-5 11-13-1-7 1-10 8-11 2 1 2 4 2 6 0 11 6 15 15 18 14 6 27 15 44 15 3 0 5 2 8 4Z"
      />
    </g>
  </g>
</g>
    {#if isPaused}
    <svg viewBox="-6 -5 36 36" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z"/></svg>
    {/if} 
  </svg>